import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "moment/locale/fr";
import {
  addCandidateReference,
  deleteCandidateReference,
  updateCandidateReference,
} from "../../../redux/actions/admin/CandidateActions";
import "moment/locale/fr";
import { CircularProgress } from "@material-ui/core";
import localStorageService from "../../../services/localStorageService";
import CustomAlert  from "../../shared/views/CustomAlert";

let ReferenceResume = (props) => {
  const {
    referenceList,
    addCandidateReference,
    deleteCandidateReference,
    updateCandidateReference,
  } = props;

  const closeDeleteReferenceModal = React.useRef();
  const [
    displayingCandidateReferenceList,
    setDisplayCandidateReferenceList,
  ] = React.useState([]);
  const [showReferenceForm, setShowReferenceForm] = React.useState(false);
  const [showUpdateForm, setShowUpdateForm] = React.useState({});
  const [isReferenceAdding, setIsReferenceAdding] = React.useState(false);
  const [isReferenceUpdating, setIsReferenceUpdating] = React.useState(false);
  const [isReferenceDeletting, setIsReferenceDeletting] = React.useState(false);
  const [published, setPublished] = React.useState(false);
  const [referenceTodelete, setReferenceTodelete] = React.useState(null);
  const [addReferenceFailed, setAddReferenceFailed] = React.useState(false);
  const [candidate, setCandidate] = React.useState(null);
  const [newReference, setNewReference] = React.useState({
    candidateId: "",
    fullName: "",
    title: "",
    email: "",
    phoneNumber1: "",
    phoneNumber2: "",
  });
  const [referenceToUpdate, setReferenceToUpdate] = React.useState({});

  useEffect(() => {
    if (referenceList !== null && displayingCandidateReferenceList.length === 0) {
      setDisplayCandidateReferenceList(referenceList);
    }
  }, [referenceList]);

  const toggleForm = () => {
    setShowReferenceForm(!showReferenceForm);
  };

  const toggleUpdateForm = (reference) => {
    setReferenceToUpdate(reference);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [reference.id]: !prevState[reference.id],
    }));
  };

  const handleCreateReferenceSubmit = async () => {
    setIsReferenceAdding(true);
    let reference = newReference;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    reference.candidateId = candidate.id;
    try {
      const data = await addCandidateReference(reference);
      if (data.success) {
        setAddReferenceFailed(false);
        setDisplayCandidateReferenceList(data.candidate.references);
        setCandidate(data.candidate);
        clearReferenceForm();
        
      }
      setIsReferenceAdding(false);
      setPublished(true);
      setShowReferenceForm(false);
      
    } catch (error) {
      setAddReferenceFailed(true);
    }
  };
  const clearReferenceForm = () => {
    setNewReference({
      candidateId: "",
        fullName: "",
        title: "",
        email: "",
        phoneNumber1: "",
        phoneNumber2: "",
    });
  };
  const handleUpdateReferenceSubmit = () => {
    setIsReferenceUpdating(true);
    let reference = referenceToUpdate;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    reference.candidateId = candidate.id;

    updateCandidateReference(reference).then((data) => {
      if (data.success) {
        setDisplayCandidateReferenceList(data.candidate.references);
        setCandidate(data.candidate);
      }
      setIsReferenceUpdating(false);
      setPublished(false);
      toggleUpdateForm(reference);
    });
  };

  const handleDeleteReferenceSubmit = () => {
    setIsReferenceDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteCandidateReference(candidate?.id, referenceTodelete?.id).then(
      (resp) => {
        if (resp.success === true) {
          setDisplayCandidateReferenceList(resp.candidate.references);
          setCandidate(resp.candidate);
        }
        setReferenceTodelete("");
        closeDeleteReferenceModal.current.click();
        setIsReferenceDeletting(false);
      }
    );
  };

  return (
    <React.Fragment>
      <div className="bg-light-3 p-4">
        <div className="row">
          <div className="col-md-7 col-sm-5 d-flex align-items-center">
            <div className="section-title mb-0 ">
              <h3 className="title mb-0">
                {" "}
                <span>Références</span>
              </h3>
            </div>
          </div>
          <div
            className="col-md-5 col-sm-7 mt-3 mt-sm-0 pr-3"
            style={{ textAlign: "right" }}
          >
            <button className="btn btn-primary" onClick={toggleForm}>
              Ajouter une référence
            </button>
          </div>
        </div>
        <div className="row">
          {showReferenceForm == true && (
            <div className="col-xl-12">
              <div className="mt-4">
                <div className="bg-light-3">
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label>Nom complet *</label>
                        <input
                          value={newReference.fullName}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return { ...prevState, fullName: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <label>Titre *</label>
                        <input
                          value={newReference.title}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return {
                                ...prevState,
                                title: val,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <label>Email *</label>
                        <input
                          value={newReference.email}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return {
                                ...prevState,
                                email: val,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Numéro de téléphone 1 * </label>
                        <input
                          value={newReference.phoneNumber1}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return {
                                ...prevState,
                                phoneNumber1: val,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Numéro de téléphone 2 </label>
                        <input
                          value={newReference.phoneNumber2}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return {
                                ...prevState,
                                phoneNumber2: val,
                              };
                            });
                          }}
                        />
                      </div>

                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateReferenceSubmit}
                          disabled={isReferenceAdding}
                          style={{ textAlign: "right", float: "right" }}
                        >
                          Ajouter &nbsp;{" "}
                          {isReferenceAdding ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                        &nbsp;{" "}
                        &nbsp;{" "}
                        {addReferenceFailed && (
                            <div  className="col-12 mt-5">
                               <CustomAlert content="Erreur lors de cette opération, veuillez réessayer" type="alert-danger" />
                            </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          )}
        </div>
        <div className="row">
          <div className="col-xl-12 mt-4">
            {displayingCandidateReferenceList?.length !== 0 && (
              <div className="timeline-box bg-white p-3 ">
                {displayingCandidateReferenceList?.map((reference, index) => (
                  <div className="jobster-timeline-item" key={index}>
                    <div className="jobster-timeline-info">
                      <div className="dashboard-timeline-info">
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-10">
                                    <span className="text-dark">
                                      <h6>
                                      <strong>{reference.fullName}</strong>
                                      </h6>
                                    </span>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-12">
                                            <div className="mt-2">{reference.title}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-6">
                                            <div className="mt-2">Tel: {reference.phoneNumber1} / {reference.phoneNumber2}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-10">
                                            <div className="mt-2">Email: {reference.email}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <div className="dashboard-timeline-edit">
                                      <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                        <li className="pr-2">
                                          <a
                                            href="javascript:void(0)"
                                            onClick={() =>
                                              toggleUpdateForm(reference)
                                            }
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            className="text-danger"
                                            data-toggle="modal"
                                            title=""
                                            data-target="#deleteReference"
                                            data-original-title="Delete"
                                          >
                                            <i
                                              className="far fa-trash-alt text-danger"
                                              onClick={() =>
                                                setReferenceTodelete(reference)
                                              }
                                            ></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            {showUpdateForm[reference.id] && (
                              <div className="col-12">
                              <div className="mt-4">
                                <div className="bg-light-3 p-4">
                                  <div _lpchecked="1">
                                    <div className="form-row">
                                      <div className="form-group col-md-12">
                                        <label>Nom  complet </label>
                                        <input
                                          value={
                                            referenceToUpdate.fullName
                                          }
                                          type="text"
                                          className="form-control"
                                          id="title"
                                          onChange={(e) => {
                                            let val = e.target?.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  fullName: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group col-md-12">
                                        <label>
                                          Titre{" "}
                                        </label>
                                        <input
                                          value={
                                            referenceToUpdate.title
                                          }
                                          type="text"
                                          className="form-control"
                                          id="title"
                                          onChange={(e) => {
                                            let val = e.target?.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  title: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group col-md-12">
                                        <label>Email </label>
                                        <input
                                          value={
                                              referenceToUpdate.email
                                          }
                                          id="email"
                                          className="form-control"
                                          onChange={(
                                            selectedOption
                                          ) => {
                                            let val =
                                              selectedOption.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  email: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group col-md-6">
                                      <label>Numéro de téléphone 1 </label>
                                        <input
                                          value={
                                              referenceToUpdate.phoneNumber1
                                          }
                                          id="phoneNumber1"
                                          className="form-control"
                                          onChange={(
                                            selectedOption
                                          ) => {
                                            let val =
                                              selectedOption.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  phoneNumber1: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                        {/* {invalideDate && (
                                          <p style={{ color: "red" }}>
                                            Format invalide
                                          </p>
                                        )} */}
                                      </div>
                                      <div className="form-group col-md-6">
                                      <label>Numéro de téléphone 2 </label>
                                        <input
                                          value={
                                              referenceToUpdate.phoneNumber2
                                          }
                                          id="phoneNumber2"
                                          className="form-control"
                                          onChange={(
                                            selectedOption
                                          ) => {
                                            let val =
                                              selectedOption.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  phoneNumber2: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                        {/* {invalideDate && (
                                          <p style={{ color: "red" }}>
                                            Format invalide
                                          </p>
                                        )} */}
                                      </div>
                                      <div className="col-12 mt-4">
                                        <button
                                          className="btn btn-primary"
                                          onClick={
                                            handleUpdateReferenceSubmit
                                          }
                                          disabled={
                                            isReferenceUpdating
                                          }
                                          style={{
                                            textAlign: "right",
                                            float: "right",
                                          }}
                                        >
                                          Mettre à jour &nbsp;{" "}
                                          {isReferenceUpdating ? (
                                            <CircularProgress
                                              size={15}
                                            />
                                          ) : (
                                            <span></span>
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Start Delete  modale */}
        <div
          className="modal fade"
          id="deleteReference"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header p-4">
                <h4 className="mb-0 text-center">Suppression d'une référence</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form className="mt-2">
                <div className="modal-body">
                  <div>
                    <div className="form-row">
                      <p>
                        Voulez vous supprimer cette référence:{" "}
                        {referenceTodelete?.name}?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className="btn btn-primary"
                    ref={closeDeleteReferenceModal}
                  >
                    NON
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleDeleteReferenceSubmit}
                    disabled={isReferenceDeletting}
                  >
                    OUI &nbsp;{" "}
                    {isReferenceDeletting ? (
                      <CircularProgress size={15} />
                    ) : (
                      <span></span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* End Delete  modale */}
      </div>
    </React.Fragment>
  );
};

ReferenceResume.propTypes = {
  addCandidateReference: PropTypes.func.isRequired,
  deleteCandidateReference: PropTypes.func.isRequired,
  updateCandidateReference: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  addCandidateReference: PropTypes.func.isRequired,
  deleteCandidateReference: PropTypes.func.isRequired,
  updateCandidateReference: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  addCandidateReference,
  deleteCandidateReference,
  updateCandidateReference,
})(ReferenceResume);
